
































































































































import SimpleMap from '../../core/components/SimpleMap.vue';
import SimpleTable from '../../core/components/SimpleTable.vue';
import CalibrationPeriods from './CalibrationPeriods.vue';
import SegmentsTable from './SegmentsTable.vue';
import AlertBox from '../../core/components/AlertBox.vue';
import ListWithItems from '../../core/components/ListWithItems.vue';
import $ from 'jquery';
import {
    EventBus,
    hasElements,
    TypeEventBus,
    sortObjectByPropertyName,
    checkIfIDExistsInArray,
    formatDate,
    parseFloatNumber,
    matchedIndexIdInArray,
    getAlertColorByPriority,
    getUniqueId
} from '../../core/utils';
import { Destroyed } from '../../core/decorators';
import { Component, Prop, Mixins, Vue, Watch, Emit } from 'vue-property-decorator';
import { PRIVILEGE_KEYS, PRIVILEGE_TYPES } from '../../core/utils/privileges';
import {
    MsgBox,
    Button,
    Combobox,
    LoadingDialog,
    PlusEyeButtons,
    Breadcrums,
    CloseConfirmationModal
} from '../../core/components';
import {
    AuthStoreHelper,
    RootStoreHelper,
    CompanyStoreHelper,
    StoreHelper,
    NotificationStoreHelper
} from '../../core/mixins';
import multiselect from 'vue-multiselect';
import Axios from 'axios';
import { InsuranceServices } from '../api/InsuranceServices';
import Loading from 'vue-loading-overlay';
import { config } from 'rxjs';
import moment from 'moment';
import { getParsedBounds } from '../utils';

@Component({
    components: {
        Loading,
        SimpleMap,
        SimpleTable,
        Combobox,
        Button,
        LoadingDialog,
        CalibrationPeriods,
        SegmentsTable,
        AlertBox,
        ListWithItems
    }
})
export default class PreviewRanchSimulation extends Mixins(
    AuthStoreHelper,
    StoreHelper,
    RootStoreHelper,
    CompanyStoreHelper,
    NotificationStoreHelper
) {
    @Prop({ default: {} }) previewData: object;
    @Prop({ default: null }) mostRepresentativeImage: object | null;
    @Prop({ default: null }) geojsonSegmentsOfWork: object | null;
    @Prop({
        default() {
            return [];
        }
    })
    vehiclesOptions: Array<object>;
    @Prop({ default: -1 }) harvestId: number;
    selectedTab: any = null;
    oldCalibrationPeriods: Array<object> = [];
    newCalibrationPeriods: Array<object> = [];
    vehicleTimelines: object = {};
    itemsSegments: Array<object> = [];
    colorReferences: Array<object> = [
        {
            color: '#ffce84',
            value: 'Valores Anteriores'
        },
        {
            color: '#9be19b',
            value: 'Valores Previsualización'
        }
    ];
    oldPerformance: number = 0;
    oldHumidity: number = 0;
    newPerformance: number = 0;
    newHumidity: number = 0;
    loadingMap: boolean = true;
    showCharts: boolean = false;
    alertPreview: string = 'Los valores no son 100% representativos';
    noSegmentsToShow: string = 'La chacra no tiene recorridos para mostrar';
    oldLayersItems: object = {
        old_see_performance_csv: {
            title: 'Mapa Rinde',
            key: 'old_see_performance_csv',
            checked: true,
            disabled: false,
            disabledTooltip: 'No hay imágenes de Rinde CSV',
            icon: 'mdi-barley'
        },
        old_machine_travel: {
            title: 'Recorrido máquinas',
            key: 'old_machine_travel',
            checked: false,
            disabled: false,
            disabledTooltip: 'No hay recorridos para mostrar',
            icon: 'mdi-tractor'
        },
        old_see_most_representative: {
            title: 'Imagen Representativa',
            key: 'old_see_most_representative',
            checked: false,
            disabled: false,
            disabledTooltip: 'No fue seleccionada ninguna imagen como representativa',
            icon: 'mdi-satellite-variant'
        }
    };
    newLayersItems: object = {
        new_see_performance_csv: {
            title: 'Mapa Rinde',
            key: 'new_see_performance_csv',
            checked: true,
            disabled: false,
            disabledTooltip: 'No hay imágenes de Rinde CSV',
            icon: 'mdi-barley'
        },
        new_machine_travel: {
            title: 'Recorrido máquinas',
            key: 'new_machine_travel',
            checked: false,
            disabled: false,
            disabledTooltip: 'No hay recorridos para mostrar',
            icon: 'mdi-tractor'
        },
        new_see_most_representative: {
            title: 'Imagen Representativa',
            key: 'new_see_most_representative',
            checked: false,
            disabled: false,
            disabledTooltip: 'No fue seleccionada ninguna imagen como representativa',
            icon: 'mdi-satellite-variant'
        }
    };

    dataWarning: string = 'Los valores mostrados en este simulador son aproximados.<br> Estos valores se basan en el ultimo reporte calculado y las configuraciones actuales del simulador<br> y no reflejan los cambios desde el ultimo reporte. Para mayor precisión, considere recalcular la chacra.'

    get existSegmentsInMap(){
        if(this.geojsonSegmentsOfWork !== null){
            return true
        }
        return false
    }

    get modalSegmentsTable(): HTMLFormElement {
        return this.$refs.segmentsTable as HTMLFormElement;
    }
    get mapOldChanges(): HTMLFormElement {
        return this.$refs.mapOriginalConfig as HTMLFormElement;
    }
    get mapNewChanges(): HTMLFormElement {
        return this.$refs.mapWithChanges as HTMLFormElement;
    }

    showGeojsonSegmentsOfWork(){
        this.toggleGeojsonSegmentsOfWorkOldMap(true);
        this.toggleGeojsonSegmentsOfWorkNewMap(true);
    }

    togglePerformanceMapOldConfig(visible: boolean){
        this.showPerformanceOldImage(visible);
    }

     itemChangedOldConfig(item) {
        switch (item['key']) {
            case 'old_see_performance_csv':
                this.showPerformanceOldImage(item['checked']);
                break;
            case 'old_machine_travel':
                this.toggleGeojsonSegmentsOfWorkOldMap(item['checked']);
                break;
            case 'old_see_most_representative':
                this.toggleMostRepresentativeOldImage(item['checked']);
                break;
        }
    }
     itemChangedNewConfig(item) {
        switch (item['key']) {
            case 'new_see_performance_csv':
                this.showPerformanceNewImage(item['checked']);
                break;
            case 'new_machine_travel':
                this.toggleGeojsonSegmentsOfWorkNewMap(item['checked']);
                break;
            case 'new_see_most_representative':
                this.toggleMostRepresentativeNewImage(item['checked']);
                break;
        }
    }

     selectPolylineInWorkSegments(feature: google.maps.Data.Feature) {
        //select a polyline clicked from map to work segments table
        let startDate = feature.getProperty('start');
        let endDate = feature.getProperty('end');
        //find polyline in work segments and select it;
        let indexPolylineInWorkSegments = this.itemsSegments.findIndex(
            segment => segment['start_date'] === startDate && segment['end_date'] === endDate
        );
        if (indexPolylineInWorkSegments !== -1) {
            let segmentsTableComponent:any = this.modalSegmentsTable[this.selectedTab];
            segmentsTableComponent.addSegmentToSelectedOnes(this.itemsSegments[indexPolylineInWorkSegments]);
        }
    }
    toggleMostRepresentativeOldImage(visible){
        if (visible && this.mostRepresentativeImage) {
            this.oldLayersItems['old_see_most_representative']['disabled'] = false;
            let url = this.mostRepresentativeImage['png_url'];
            let bounds = this.mostRepresentativeImage['bounds'];
            let imgBounds = getParsedBounds(bounds);
            this.mapOldChanges.setGroundOverlayInMap(url, imgBounds, false);
        } else {
            if (this.mostRepresentativeImage !== null) {
                this.mapOldChanges.hideGroundOverlayFromMap(this.mostRepresentativeImage['png_url']);
            }
        }
    }
    toggleMostRepresentativeNewImage(visible){
        if (visible && this.mostRepresentativeImage) {
            this.newLayersItems['new_see_most_representative']['disabled'] = false;
            let url = this.mostRepresentativeImage['png_url'];
            let bounds = this.mostRepresentativeImage['bounds'];
            let imgBounds = getParsedBounds(bounds);
            this.mapNewChanges.setGroundOverlayInMap(url, imgBounds, false);
        } else {
            if (this.mostRepresentativeImage !== null) {
                this.mapNewChanges.hideGroundOverlayFromMap(this.mostRepresentativeImage['png_url']);
            }
        }
    }

    updateSelectedSegmentsInMap(elements) {
        if(elements.length > 0){
           this.oldLayersItems['old_machine_travel']['checked'] = true;
           this.newLayersItems['new_machine_travel']['checked'] = true;
           this.toggleGeojsonSegmentsOfWorkOldMap(true);
           this.toggleGeojsonSegmentsOfWorkNewMap(true);   
        }else{
           this.oldLayersItems['old_machine_travel']['checked'] = false;
           this.newLayersItems['new_machine_travel']['checked'] = false;
           this.toggleGeojsonSegmentsOfWorkOldMap(false);
           this.toggleGeojsonSegmentsOfWorkNewMap(false);
        }
        this.mapOldChanges.selectSegmentsOfWork(elements);
        this.mapNewChanges.selectSegmentsOfWork(elements);  
    }

    toggleGeojsonSegmentsOfWorkOldMap(visible){
        if(visible){
            this.mapOldChanges.showSegmentsOfWork(this.geojsonSegmentsOfWork);
        }else{
            this.mapOldChanges.hideSegmentsOfWork();
        }
    }

    toggleGeojsonSegmentsOfWorkNewMap(visible){
        if(visible){
            this.mapNewChanges.showSegmentsOfWork(this.geojsonSegmentsOfWork);
        }else{
            this.mapNewChanges.hideSegmentsOfWork();
        }
    }

    getVehicleDescription(id: number) {
        let data = this.getVehicleData(id);
        return data['description'] + '(' + data['vin'] + ')';
    }

    getCurrentVehicle() {
        if (this.previewData && this.previewData['currentVehicle']) {
            return this.previewData['currentVehicle'];
        }
    }

    get getAlertColor() {
        return getAlertColorByPriority();
    }

    mounted() {
        let self = this;
        this.$nextTick(() => {
            setTimeout(() => {
                self.loadOldConfig();
                self.loadNewConfig();
                self.checkIfCanEnableWorkSegments();
                self.checkIfCanEnableMostRepresentativeImage();
                self.setWorkSegments();
                self.showCharts = true;
                self.setLoadingMap(false);
            }, 500);
        });
    }

    checkIfCanEnableWorkSegments(){
        if(this.geojsonSegmentsOfWork == null){
           this.oldLayersItems['old_machine_travel']['disabled'] = true;
           this.newLayersItems['new_machine_travel']['disabled'] = true;
        }
    }

    checkIfCanEnableMostRepresentativeImage(){
        if(this.mostRepresentativeImage == null){
           this.oldLayersItems['old_see_most_representative']['disabled'] = true;
           this.newLayersItems['new_see_most_representative']['disabled'] = true;
        }
    }

    setLoadingMap(value) {
        this.loadingMap = value;
    }

    setOldPerformance(value) {
        this.oldPerformance = this.parseValue(value);
    }
    setNewPerformance(value) {
        this.newPerformance = this.parseValue(value);
    }
    setOldHumidity(value) {
        this.oldHumidity = this.parseValue(value);
    }
    setNewHumidity(value) {
        this.newHumidity = this.parseValue(value);
    }
    setVehicleTimelines(list) {
        this.vehicleTimelines = list;
    }
    setWorkSegments() {
        let self = this;
        let items = this.previewData['newConfig']['segments_stats'];
        if (items.length > 0) {
            items = items.map(function(item) {
                
                return {
                    ...item,
                    customId: self.getSegmentCustomIdInGeojsonSegments(item['start_date'], item['end_date'], item['vehicle']),
                    old_performance_calibration_factor: item['original_data']['performance_calibration_periods'],
                    old_humidity_calibration_factor: item['original_data']['humidity_calibration_periods'],
                    old_performance: item['original_data']['performance'],
                    old_humidity: item['original_data']['humidity'],
                    new_performance_calibration_factor: item['preview_data']['performance_calibration_periods'],
                    new_humidity_calibration_factor: item['preview_data']['humidity_calibration_periods'],
                    new_performance: item['preview_data']['performance'],
                    new_humidity: item['preview_data']['humidity'],
                    vehicle: self.getVehicleData(item['vehicle'])
                };
            });
        }
        this.itemsSegments = items;
    }

    getSegmentCustomIdInGeojsonSegments(startDate, endDate, vehicleId){
        if(this.geojsonSegmentsOfWork !== null){
            let index = this.geojsonSegmentsOfWork['features'].findIndex(
                item => item['properties']['start'] === startDate && 
                item['properties']['end'] === endDate && 
                item['properties']['vehicle'] == vehicleId
            )
            if(index !== -1){
                return this.geojsonSegmentsOfWork['features'][index]['properties']['customId']
            }
        }
    }

    getSegmentsTable(vehicle) {
        console.log('vehicle', vehicle);
        let currentVehicleId = Number(vehicle[0]);
        let items: Array<object> = [];
        if (this.itemsSegments.length !== 0) {
            for (let i = 0; i < this.itemsSegments.length; i++) {
                let item = this.itemsSegments[i];
                if (item['vehicle']['id'] == currentVehicleId) {
                    items.push(item);
                }
            }
        }
        return items;
    }

    getVehicleData(vehicleId: number) {
        let data = '';
        let index = matchedIndexIdInArray(this.vehiclesOptions, vehicleId);
        if (index > -1) {
            let vehicle = this.vehiclesOptions[index];
            return vehicle;
        }
        return data;
    }

    parseValue(value) {
        return parseFloatNumber(value);
    }

    loadOldConfig() {
        //set top values
        this.setOldPerformance(this.previewData['oldConfig']['ranch']['performance']);
        this.setNewHumidity(this.previewData['oldConfig']['ranch']['humidity']);

        //set performance image
        this.showPerformanceOldImage(true);
    }

    showPerformanceNewImage(visible: boolean){
       if (
            this.previewData['newConfig'] &&
            this.previewData['newConfig'] &&
            this.previewData['newConfig']['image'] !== null
        ) {
            if(visible){
                let imageBounds = getParsedBounds(this.previewData['newConfig']['ranch_stats']['bounds']);
                this.mapNewChanges.setGroundOverlayInMap(this.previewData['newConfig']['image'], imageBounds, true);
                this.mapNewChanges.fitBounds(imageBounds);
            }else{
                this.mapNewChanges.hideGroundOverlayFromMap(
                   this.previewData['newConfig']['image'],
                );
            }
        }
    }
    showPerformanceOldImage(visible: boolean){
        if (
            this.previewData['oldConfig'] &&
            this.previewData['oldConfig']['images'] &&
            this.previewData['oldConfig']['images']['performance_telemetry_transparent'] !== null
        ) {
            if(visible){
                let imageBounds = getParsedBounds(this.previewData['oldConfig']['bounds']);
                this.mapOldChanges.setGroundOverlayInMap(
                    this.previewData['oldConfig']['images']['performance_telemetry_transparent'],
                    imageBounds,
                    true
                );
                this.mapOldChanges.fitBounds(imageBounds);
            }else{
                this.mapOldChanges.hideGroundOverlayFromMap(
                    this.previewData['oldConfig']['images']['performance_telemetry_transparent'],
                );
            }
        }
    }

    loadNewConfig() {
        //set top values
        this.setNewPerformance(this.previewData['newConfig']['ranch_stats']['performance']);
        this.setOldHumidity(this.previewData['newConfig']['ranch_stats']['humidity']);

        //set performance image
        this.showPerformanceNewImage(true);
        this.setVehicleTimelines(this.previewData['newConfig']['vehicle_timelines']);
    }
}
